<template>
  <div>
    <p>
      <center>
        <b>USDT (Tether) — TRC20</b> network<br />
        <span class="wallet">TDu85GDqCGGj21CjtHH41pM2oYRmqLzq5Z</span>
        <br /><br />
        <b>USDT (Tether) — BEP20</b> network (BNB Smart Chain)<br />
        <span class="wallet">0x6aaf6364b325f3c3a5839de8632caea6068170bf</span>
        <br /><br />
      </center>
      <b
        >After transfer please send us a message with your Email and
        Transaction hash</b
      ><br />
      <a
        href="https://wa.me/353852108011?text=USDT MANUAL PAYMENT"
        target="_blank"
        >WhatsApp Contact Link</a
      >
      Or WhatsApp NR: +353 85 210 801
      <br /><br />
      <center><b>For Binance, there are 0% fees!</b></center>
    </p>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
p {
  border: 1px dashed;
  padding: 20px;
  background: #161e312b;
  text-align: left;
}
.wallet {
  display: inline-block;
  font-family: monospace;
  font-size: 0.95em;
  word-break: break-all;
  background: rgba(115, 103, 240, 0.1);
  padding: 4px 8px;
  border-radius: 4px;
  margin-top: 4px;
  user-select: all;
}
</style>
